export class UsedTimeRes{
    userId!:number
    projectId!:number
    usedTimeInHours!:number
}